import { Grid as MuiGrid, Typography as MuiTypography } from "@mui/material";
import { getString } from "app/shared/utils";
import DOMPurify from "dompurify";
import { AllowedTags } from "app/shared/constants";
import isJSON from "is-json";

const StyleApp = {
  summaryCell: {
    border: 0,
    padding: "8px 16px",
  },
  summaryLink: {
    "& a": {
      textDecoration: "none",
      color: "#007c92",
      cursor: "pointer",
    },
  },
};

const getFieldLabel = (text, fields, otherValues, wrapValuesWith) => {
  const matches = text.match(/\[.+?\]/g) || [];
  return matches.reduce((prevText, match) => {
    const key = match.slice(1, -1);

    return prevText.replace(
      match,
      getString(fields, key, otherValues, wrapValuesWith),
    );
  }, text);
};

export const FormSummaryRow = ({
  fields,
  formValues,
  formFields,
  showEmptyFields,
}) => {
  return fields.map((item, index) => {
    const fieldLabel = item?.field_label
      ? getFieldLabel(
          item.field_label,
          formValues,
          {
            formSpec: formFields,
          },
          "",
        )
      : "";
    const fieldValue =
      item?.field_id &&
      formValues[item.field_id] !== "{}" &&
      formValues[item.field_id] !== null
        ? getString(
            formValues,
            item.field_id,
            {
              formSpec: formFields,
            },
            "",
          )
        : "";

    const attributes =
      item.field_attributes && isJSON(item.field_attributes)
        ? JSON.parse(item.field_attributes)
        : null;
    const fieldType = attributes?.field_type;

    return (
      fieldLabel &&
      (fieldValue || showEmptyFields) && (
        <MuiGrid container size={12} key={`${item.field_id}-${index}`}>
          <MuiGrid size={6} sx={StyleApp.summaryCell}>
            <MuiTypography variant="body2">{fieldLabel}</MuiTypography>
          </MuiGrid>
          <MuiGrid size={5} sx={StyleApp.summaryCell}>
            <MuiTypography
              variant="body1"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  getFormattedValue(fieldValue, fieldType),
                  {
                    ALLOWED_TAGS: AllowedTags,
                  },
                ),
              }}
              sx={StyleApp.summaryLink}
            />
          </MuiGrid>
        </MuiGrid>
      )
    );
  });
};

const getFormattedValue = (inputValue, fieldType) => {
  if (fieldType === "percent") return `${parseFloat(inputValue)}%`;
  else if (fieldType === "money") {
    return `${Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    })
      .format(String(inputValue))
      .replace(/(\.|,)00$/g, "")}`;
  }
  return inputValue;
};
